var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('p',[_vm._v(_vm._s(_vm.data.copyright))])]),_c('div',{staticClass:"col-sm-5"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }